<div class="flex sm:flex-row flex-col justify-between sm:text-xs text-[8px] text-gray-400 max-h-full">
    <div
        class="relative w-full max-h-full border-2 border-dashed border-gray-300 p-2 bg-[#f4f4f4] cursor-pointer overflow-hidden group"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
    >
        <img
        [src]="image || placeholder"
        alt="Imagen"
        class="w-full h-full object-cover"
        />

        <div
        class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        >
        <button
            mat-icon-button
            class="pointer-events-auto"
            (click)="$event.stopPropagation(); uploadImage()"
        >
            <mat-icon class="text-white">cloud_upload</mat-icon>
        </button>
        </div>

        <input
        type="file"
        accept="image/jpeg, image/png"
        formControlName="image"
        (change)="onFileSelected($event)"
        class="hidden"
        #fileInput
        />
    </div>
</div>
